<template>
  <a-modal
    title="选择多多进宝"
    :width="900"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
    :bodyStyle="{}"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="查询条件">
              <a-select v-model="queryParam.type" placeholder="请选择" allowClear>
                <a-select-option value>多多进宝账户</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="多多进宝账户">
              <a-input v-model="queryParam.keywords" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <template v-if="advanced"></template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table ref="table" rowKey="owner_id" :columns="columns" :data="loadData">
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <template slot="action" slot-scope="text,record">
        <a @click="onchange(record)">选择</a>
      </template>
    </s-table>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: '序号',
    scopedSlots: { customRender: 'serial' },
    width: 60
  },
  {
    title: '多多进宝账户',
    dataIndex: 'owner_name'
  },
  {
    title: '账户ID',
    dataIndex: 'owner_id'
  },
  {
    title: '操作',
    width: 60,
    scopedSlots: { customRender: 'action' }
  }
]
import CompanyApi from '@/api/company'
import { STable } from '@/components'
export default {
  components: {
    STable
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      columns,
      loading: false,
      visible: false,
      currentRobotId: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return CompanyApi.getDuoduoList(Object.assign(parameter, this.queryParam))
      }
    }
  },
  created() {},
  methods: {
    show() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    onchange(record) {
      this.$emit('change', record)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
